const _orderId = Symbol();
const _icd10Code = Symbol();
const _customerName = Symbol();
const _customerDateOfBirth = Symbol();
const _customerGender = Symbol();
const _doctorName = Symbol();
const _doctorId = Symbol();
const _surgeryDate = Symbol();
const _limbName = Symbol();
const _startDate = Symbol();
const _stopDate = Symbol();

export class OrderDetail {
	constructor(orderId, icd10Code, customerName, customerDateOfBirth, customerGender, doctorName, doctorId, surgeryDate, limbName, startDate, stopDate) {
		this.orderId = orderId;
		this.icd10Code = icd10Code;
		this.customerName = customerName;
		this.customerDateOfBirth = customerDateOfBirth;
		this.customerGender = customerGender;
		this.doctorName = doctorName;
		this.doctorId = doctorId;
		this.surgeryDate = surgeryDate;
		this.limbName = limbName;
		this.startDate = startDate;
		this.stopDate = stopDate;
	}
	get orderId() {
		return this[_orderId];
	}
	set orderId(v) {
		if(!Number.isInteger(v))
			throw new TypeError('orderId must be an integer.');
		this[_orderId] = v;
	}
	get icd10Code() {
		return this[_icd10Code];
	}
	set icd10Code(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('icd10Code must be a string.');
		this[_icd10Code] = v;
	}
	get customerName() {
		return this[_customerName];
	}
	set customerName(v) {
		if(typeof v !== 'string')
			throw new TypeError('customerName must be a string.');
		this[_customerName] = v;
	}
	get customerDateOfBirth() {
		return this[_customerDateOfBirth];
	}
	set customerDateOfBirth(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('customerDateOfBirth must be an integer.');
		this[_customerDateOfBirth] = v;
	}
	get customerGender() {
		return this[_customerGender];
	}
	set customerGender(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('customerGender must be a string.');
		this[_customerGender] = v;
	}
	get doctorName() {
		return this[_doctorName];
	}
	set doctorName(v) {
		if(typeof v !== 'string')
			throw new TypeError('doctorName must be a string.');
		this[_doctorName] = v;
	}
	get doctorId() {
		return this[_doctorId];
	}
	set doctorId(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('doctorId must be an integer.');
		this[_doctorId] = v;
	}
	get surgeryDate() {
		return this[_surgeryDate];
	}
	set surgeryDate(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('surgeryDate must be an integer.');
		this[_surgeryDate] = v;
	}
	get limbName() {
		return this[_limbName];
	}
	set limbName(v) {
		if(v !== null && typeof v !== 'string')
			throw new TypeError('limbName must be a string.');
		this[_limbName] = v;
	}
	get startDate() {
		return this[_startDate];
	}
	set startDate(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('startDate must be an integer.');
		this[_startDate] = v;
	}
	get stopDate() {
		return this[_stopDate];
	}
	set stopDate(v) {
		if(v !== null && !Number.isInteger(v))
			throw new TypeError('stopDate must be an integer.');
		this[_stopDate] = v;
	}
	toJSON() {
		return {
			orderId: this.orderId,
			icd10Code: this.icd10Code,
			customerName: this.customerName,
			customerDateOfBirth: this.customerDateOfBirth,
			customerGender: this.customerGender,
			doctorName: this.doctorName,
			doctorId: this.doctorId,
			surgeryDate: this.surgeryDate,
			limbName: this.limbName,
			startDate: this.startDate,
			stopDate: this.stopDate
		};
	}
	static fromObject(obj) {
		if(obj === null || typeof obj !== 'object')
			throw new TypeError('obj must be an object.');
		
		return new this(
			obj.orderId || obj.OrderId || null,
			obj.icd10Code || obj.ICD10Code || null,
			obj.customerName || obj.CustomerName || '',
			(obj.customerDateOfBirth || obj.CustomerDateOfBirth) instanceof Date ? 
				(obj.customerDateOfBirth || obj.CustomerDateOfBirth).getTime() : 
				(obj.customerDateOfBirth || obj.CustomerDateOfBirth)
				|| null,
			obj.customerGender || obj.CustomerGender || '',
			obj.doctorName || obj.DoctorName || '',
			obj.doctorId || obj.DoctorId || null,
			(obj.surgeryDate || obj.SurgeryDate) instanceof Date ? 
				(obj.surgeryDate || obj.SurgeryDate).getTime() : 
				(obj.surgeryDate || obj.SurgeryDate)
				|| null,
			obj.limbName || obj.LimbName || '',
			(obj.startDate || obj.StartDate) instanceof Date ? 
				(obj.startDate || obj.StartDate).getTime() : 
				(obj.startDate || obj.StartDate)
				|| null,
			(obj.stopDate || obj.StopDate) instanceof Date ? 
				(obj.stopDate || obj.StopDate).getTime() : 
				(obj.stopDate || obj.StopDate)
				|| null
		);
	}
}